<template>
  <div :class="`text-${field.textAlign}`">
    <template v-if="hasValue">
      <div class="leading-normal">
        <component
          :key="line.value"
          v-for="line in fuzzUniq"
          class="whitespace-nowrap"
          :is="`index-${line.component}`"
          :field="line"
          :resourceName="resourceName"
        />
      </div>
    </template>
    <p v-else>&mdash;</p>
  </div>
</template>

<script>
import uniqBy from 'lodash/uniqBy'
import filter from 'lodash/filter'
import each from 'lodash/each'
import map from 'lodash/map'
import { token_set_ratio, dedupe } from 'fuzzball'

export default {
  props: ['resourceName', 'field'],

  computed: {
    /**
     * Determine if the field has a value other than null.
     */
    hasValue() {
      return this.field.lines
    },
      uniqLines() {
        // each(this.field.lines, (x) => console.log('line.value:', x.value));
        return filter(uniqBy(this.field.lines, 'value'), 'value');
      },
      fuzzUniq() {
          const u = this.uniqLines
          const options = {cutoff: 85, scorer: token_set_ratio}
          const rv = dedupe(map(u, 'value'), options)
          const result = []
          each(rv, (x) => result.push(u[x[1]]))
          return result
      }
  },
}
</script>
